'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgHeartFill } from '@common/icon';
import { useMemo } from 'react';
import CountUp from 'react-countup';
import { CartBottomCTABase, CartBottomCTADesktop } from '@/app/donation/_components/CartBottomCTABase';
import { calculateTaxDeduction } from '@/app/donation/guide/utils';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
export interface CartBottomCTAProps {
  /** 기부 금액 */
  donationAmount: number;
  /** 선택된 상품 개수 */
  selectedCount: number;
  /** 답례품 원가 총 금액 (originItemTotalPrice 합계) */
  giftBenefitAmount: number;
  /** 기부하기 버튼 클릭 핸들러 */
  onDonateClick?: () => void;
  /** 숨김 여부 (바텀시트 열릴 때 사용) */
  isHidden?: boolean;
  className?: string;
}
const calculateTotalBenefit = (donationAmount: number, giftBenefitAmount: number): number => {
  const taxBenefit = calculateTaxDeduction(donationAmount).total;
  return taxBenefit + giftBenefitAmount;
};
export const CartBottomCTA = t0 => {
  const $ = _c(43);
  const {
    donationAmount,
    selectedCount,
    giftBenefitAmount,
    onDonateClick,
    isHidden: t1,
    className
  } = t0;
  const isHidden = t1 === undefined ? false : t1;
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP, false);
  let t2;
  if ($[0] !== donationAmount || $[1] !== giftBenefitAmount) {
    t2 = calculateTotalBenefit(donationAmount, giftBenefitAmount);
    $[0] = donationAmount;
    $[1] = giftBenefitAmount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const benefitAmount = Math.floor(t2);
  let t3;
  if ($[3] !== benefitAmount) {
    t3 = <p className="font-700 text-Gray-white typo-body3"><span className="text-O-400">총{" "}<CountUp preserveValue={true} end={benefitAmount} duration={0.3} separator="," />원</span>{" "}혜택을 받을 수 있어요!</p>;
    $[3] = benefitAmount;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const toastContent = t3;
  if (isDesktop) {
    const t4 = selectedCount > 0 ? toastContent : undefined;
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="flex items-center gap-4"><SvgHeartFill className="size-16 text-O-400" /><span className="font-700 text-O-400 typo-body3">선택한 답례품도 보내드려요!</span></div>;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    let t6;
    if ($[6] !== donationAmount) {
      t6 = <div className="flex items-center gap-8"><span className="font-800 text-Gray-900 typo-h4"><CountUp preserveValue={true} end={donationAmount} duration={0.3} separator="," />원</span></div>;
      $[6] = donationAmount;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    const t7 = selectedCount === 0;
    let t8;
    if ($[8] !== selectedCount) {
      t8 = selectedCount > 0 && <span className="flex size-24 items-center justify-center rounded-pill bg-Gray-white"><span className="font-700 text-O-400 typo-caption1">{selectedCount}</span></span>;
      $[8] = selectedCount;
      $[9] = t8;
    } else {
      t8 = $[9];
    }
    let t9;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <span className="font-700 text-Gray-white typo-h5">기부하기</span>;
      $[10] = t9;
    } else {
      t9 = $[10];
    }
    let t10;
    if ($[11] !== onDonateClick || $[12] !== t7 || $[13] !== t8) {
      t10 = <Button dimensions="H56" theme="primary-fill" className="h-78 w-[335px] !rounded-large bg-O-400 hover:border-O-500 hover:bg-O-500" onClick={onDonateClick} disabled={t7}>{t8}{t9}</Button>;
      $[11] = onDonateClick;
      $[12] = t7;
      $[13] = t8;
      $[14] = t10;
    } else {
      t10 = $[14];
    }
    let t11;
    if ($[15] !== t10 || $[16] !== t6) {
      t11 = <div className="gap-40 px-20 py-12 flex-center">{t5}{t6}{t10}</div>;
      $[15] = t10;
      $[16] = t6;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    let t12;
    if ($[18] !== className || $[19] !== isHidden || $[20] !== t11 || $[21] !== t4) {
      t12 = <CartBottomCTADesktop isHidden={isHidden} className={className} toastContent={t4}>{t11}</CartBottomCTADesktop>;
      $[18] = className;
      $[19] = isHidden;
      $[20] = t11;
      $[21] = t4;
      $[22] = t12;
    } else {
      t12 = $[22];
    }
    return t12;
  }
  const t4 = selectedCount > 0 ? toastContent : undefined;
  let t5;
  if ($[23] !== donationAmount) {
    t5 = <span className="font-700 text-Gray-black typo-body1"><CountUp preserveValue={true} end={donationAmount} duration={0.3} separator="," />원</span>;
    $[23] = donationAmount;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex items-center gap-4"><SvgHeartFill className="size-12 text-O-400" /><span className="whitespace-nowrap font-700 text-O-400 typo-caption1">선택한 답례품도 보내드려요!</span></div>;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== t5) {
    t7 = <div className="flex flex-1 flex-col items-center">{t5}{t6}</div>;
    $[26] = t5;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  const t8 = selectedCount === 0;
  let t9;
  if ($[28] !== selectedCount) {
    t9 = selectedCount > 0 && <span className="flex size-20 items-center justify-center rounded-pill bg-Gray-white"><span className="font-700 text-O-400 typo-caption1">{selectedCount}</span></span>;
    $[28] = selectedCount;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="font-700 text-Gray-white typo-body3">기부하기</span>;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== onDonateClick || $[32] !== t8 || $[33] !== t9) {
    t11 = <div className="flex flex-1 items-start justify-center"><Button dimensions="H56" theme="primary-fill" className="flex-1 bg-O-400 hover:border-O-500 hover:bg-O-500 mobile:px-12" onClick={onDonateClick} disabled={t8}>{t9}{t10}</Button></div>;
    $[31] = onDonateClick;
    $[32] = t8;
    $[33] = t9;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== t11 || $[36] !== t7) {
    t12 = <div className="flex items-center gap-12 px-20 py-12">{t7}{t11}</div>;
    $[35] = t11;
    $[36] = t7;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== className || $[39] !== isHidden || $[40] !== t12 || $[41] !== t4) {
    t13 = <CartBottomCTABase isHidden={isHidden} className={className} toastContent={t4}>{t12}</CartBottomCTABase>;
    $[38] = className;
    $[39] = isHidden;
    $[40] = t12;
    $[41] = t4;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  return t13;
};